import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BlockUIService, BlockUIState } from './block-ui.service';

@Component({
  standalone: false,
  selector: 'app-block-ui',
  template: `
    <div class="block-ui-wrapper">
      <ng-content></ng-content>
      <div class="block-ui-overlay" *ngIf="state.isBlocking">
        <div class="block-ui-spinner">
          <div class="block-ui-spinner__loader"></div>
          <div class="block-ui-spinner__message" *ngIf="state.message">{{ state.message }}</div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .block-ui-wrapper {
      position: relative;
      height: 100%;
    }
    .block-ui-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .block-ui-spinner {
      text-align: center;
    }
    .block-ui-spinner__loader {
      display: inline-block;
      width: 64px;
      height: 64px;
      border: 6px solid rgba(255, 255, 255, 0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: block-ui-spin 0.8s linear infinite;
    }
    .block-ui-spinner__message {
      color: #fff;
      margin-top: 12px;
      font-size: 1.1em;
      font-weight: 500;
    }
    @keyframes block-ui-spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class BlockUIComponent implements OnInit, OnDestroy {
  state: BlockUIState = { isBlocking: false, message: '' };
  private subscription: Subscription;

  constructor(private blockUIService: BlockUIService) {}

  ngOnInit(): void {
    this.subscription = this.blockUIService.blocking$.subscribe(
      (s) => (this.state = s)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
